<template>
  <v-app>
    <v-app-bar app>
      <router-link to="/" class="pt-2">
        <img src="./assets/icon_40.png" />
      </router-link>
      <v-toolbar-title class="text-h5 text-uppercase">
        <span class="ml-5 font-weight-light">{{ $t('rosa') }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          v-if="$environment !== 'production'"
          text
          :to="{ name: 'Statistic' }"
          :style="!$vuetify.theme.dark ? 'color:rgba(0,0,0,.8);' : ''"
        >
          <v-icon left>mdi-chart-bar</v-icon>
          Statistik
        </v-btn>
        <v-btn
          text
          :href="`https://www.resol.de/${$i18n.locale}/kontakt`"
          target="_blank"
          :style="!$vuetify.theme.dark ? 'color:rgba(0,0,0,.8);' : ''"
        >
          <v-icon left>mdi-email-outline</v-icon>
          {{ $t('contact') }}
        </v-btn>
        <v-btn
          text
          @click="updateTheme"
          :style="!$vuetify.theme.dark ? 'color:rgba(0,0,0,.5);' : ''"
        >
          <v-icon size="20" style="margin-top: 4px;">mdi-brightness-4</v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-menu :nudge-width="100">
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span class="text-body-1">
              <v-icon style="margin-bottom: 2px;" size="20">mdi-earth</v-icon> {{ $i18n.locale.toUpperCase() }}
            </span>
            <v-icon>mdi-chevron-down</v-icon>
          </v-toolbar-title>
        </template>
        <v-list>
          <v-list-item
            v-for="(lang, i) in langs"
            :key="`lang-${i}`"
            @click="updateLanguage(lang)"
          >
            <v-list-item-title>{{ lang.toUpperCase() }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main class="mt-12">
      <v-container style="max-width: 1150px;">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app>
      <div class="text-body-2">
        <a
          style="color: #696969;text-decoration: none;"
          :href="`https://www.resol.de/${$i18n.locale}/agb`"
          target="_blank"
        >
          {{ $t('generalTermsConditions') }}
        </a>
        <a
          class="mx-10"
          style="color: #696969;text-decoration: none;"
          :href="`https://www.resol.de/${$i18n.locale}/impressum`"
          target="_blank"
        >
          {{ $t('imprint') }}
        </a>
        <a
          style="color: #696969;text-decoration: none;"
          :href="`https://www.resol.de/${$i18n.locale}/datenschutz`"
          target="_blank"
        >
          {{ $t('privacyPolicy') }}
        </a>
      </div>
      <v-spacer></v-spacer>
      <div class="text-body-2">
        <a
          style="color: #696969;text-decoration: none;"
          :href="`https://www.resol.de/${$i18n.locale}`"
          target="_blank"
        >
          Copyright &copy; {{ new Date().getFullYear() }} RESOL GmbH
        </a>
      </div>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  created () {
    const lng = this.$ls.get('rosa-lng')
    const theme = this.$ls.get('rosa-theme')
    if (lng) {
      this.$i18n.locale = lng
    }
    if (theme && theme === 'dark') {
      this.$vuetify.theme.dark = true
    } else if (theme && theme === 'light') {
      this.$vuetify.theme.dark = false
    }
  },
  data: () => ({
    langs: ['de', 'en', 'fr', 'es', 'it']
  }),
  computed: {
    urlLng: function () {
      return this.$route.query
    }
  },
  watch: {
    urlLng () {
      if (this.urlLng && this.urlLng.lng && this.langs.indexOf(this.urlLng.lng) !== -1) {
        this.updateLanguage(this.urlLng.lng)
      }
    }
  },
  methods: {
    updateLanguage (lng) {
      this.$i18n.locale = lng
      this.$ls.set('rosa-lng', lng)
    },
    updateTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.$ls.set('rosa-theme', this.$vuetify.theme.dark ? 'dark' : 'light')
    }
  }
}
</script>

<style>
.device-img {
  border-radius: 6%;
}
</style>
